import SimpleLightbox from "simplelightbox";
const initLightbox = () =>{
  const lightbox = new SimpleLightbox('.lightbox-gallery a', { /* options */ });
}

export default initLightbox;
